import { Component, OnInit } from "@angular/core";
import { Store } from '@ngrx/store';
import {
  ApplicationState,
  getCopperOutPhasingOffer,
  getCtaFilterConfig,
  getProductsEmbeddedErrors,
  getProductsPending,
  getProductsRedirectedToDetails,
  getProductsTechnicalError,
  getSelectedAddress,
  getUserProduct,
} from '../../../store/reducers';
import * as ProductsActions from '../../../store/actions/products.actions';
import * as OffersActions from '../../../store/actions/offers.actions';
import * as MagnoliaConfigActions from '../../../store/actions/magnolia-config.actions';
import { OnDestroyHookDirective } from '../../../shared/hooks';
import {
  findMyMobileProduct,
  Location,
  MyMobileProductModel,
  OverviewCardType,
  Pack,
  Product,
} from '@dch/products-business-logic';
import {
  CustomerService,
  LanguageService,
  TranslationService,
} from '@proximus/ng-common';
import {ActivatedRoute, Router} from '@angular/router';
import {IOffer} from '@proximus/common-business-logic';
import {savePiiProduct} from '../../../shared/pii/pii.utils';
import {BrandService} from 'src/app/services/brand.service';
import {AlwaysProtectedCheckService} from "../../../services/always-protected-check.service";
import {
  EASY_PROTECT_NAME,
  NORTON_SEC_5,
  PXS_SECURE_NET_FIX,
  PXS_SECURE_NET_MOBILE
} from "src/app/always-protected-check.constants";
import {MultiLanguageLinkConfig} from "@dch/products-business-logic/src/shared/models/config.model";
import {getProductMpcuidList, JwtUtils, shouldRedirectToEshareUserJourney, constructEshareUrl} from "../../util/overview-util";
import {delay, take, tap} from "rxjs/operators";


export const enum OverviewPackType {
  mobileOnly = 'mobileOnly',
  internetOnly = 'internetOnly',
  mobileAndInternet = 'mobileAndInternet',
  packWithMobile = 'packWithMobile',
  packWithoutMobile = 'packWithoutMobile',
}

export interface OverviewCtaFilter {
  cta: Array<string>;
  doAutoRedirect: boolean;
  doCheckLomId: boolean;
  packType: OverviewPackType;
}

export interface OverviewCtaFilterConfig {
  packs: Array<OverviewCtaFilter>;
  mobile: Array<OverviewCtaFilter>;
  internet: Array<OverviewCtaFilter>;
  pack_nbo: Array<OverviewCtaFilter>;
}

declare let inception;

@Component({
  selector: 'mprd-overview',
  templateUrl: './overview.component.html',
})
export class OverviewComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  public ctaFilterConfig: OverviewCtaFilterConfig;

  public currentPackType: OverviewPackType;
  public itentFromEshare: string;
  public lomIdFromEshare: string;
  public mpcuidFromEshare: string;
  public actionFromEshare: string;
  public filterCtaApplied = false;
  public isDynamicCtaActivated = false;
  public isEshareUserJourneyEnabled = false;
  public eshareMpcuidDisallowlist: string;

  public overviewDataLoaded: boolean;

  public emptyInstallBase: boolean;
  public emptyInstallBaseNewCust: boolean;
  public emptyInstallBaseCeaseCust: boolean;
  public emptyInstallBaseV1Cust: boolean;
  public selectedAddress: any;

  public packs: Array<Pack> = [];
  public outOfPacks: Array<Pack> = [];
  public extraServices: Array<Product> = [];
  norton1MpcUuid: string;
  norton1Count: number;
  norton1LicenseCount: number;
  norton5MpcUuid: string;
  norton5Count: number;
  norton5LicenseCount: number;
  isAlwaysProtectedFeatureFlag: boolean;
  public installationAddresses: { [key: string]: Location };
  public hasProductWithoutAddress: boolean;
  public hasOnlyProductsWithoutAddress: boolean;
  public cardType = OverviewCardType;
  public myMobile: MyMobileProductModel;
  public firstCoreProduct: Product;
  private alreadyRedirected: boolean;
  public isPending: boolean;
  public outOfPacksFiberEligible: boolean;
  public addressKeyForRedirect: string;
  public isRES: boolean;
  public isSE: boolean;
  public isEBU: boolean;
  public isPrepaid: boolean;
  public hasCustomerId: boolean;
  public custumerAccountName: string;

  public copperOutPhasingOffer: IOffer;
  easyProtectOptions=[];
  hasProductDescription: boolean;
  easyProtectFlag: boolean;
  filteredData;
  isOutOfPackNorton: boolean;
  public nortonSubscriptionGreaterThanOne: boolean;
  outOfPackNorton: Product[];

  constructor(
    private _store: Store<ApplicationState>,
    private customerService: CustomerService,
    private languageService: LanguageService,
    private translationService: TranslationService,
    private router: Router,
    private brandService: BrandService,
    private alwaysProtectedService: AlwaysProtectedCheckService,
    private route: ActivatedRoute
  ) {
    super();
  }

  ngOnInit() {
    this.determineIntentPageFromEshare();
    this.determineLomIdFromEshare();
    this.determineMpcuidFromEshare();
    this.determineActionFromEshare();
    if(this.itentFromEshare) {
      this._store.dispatch(new MagnoliaConfigActions.GetSettingsCtaFilterConfig());
    }
    this.emptyInstallBase = false;
    this.emptyInstallBaseCeaseCust = false;
    this.emptyInstallBaseNewCust = false;
    this.emptyInstallBaseV1Cust = false;
    this.getProducts();
    this.getCopperOutPhasingOffer();
    this.isAlwaysProtectedFeatureFlag = ((this.translationService.getTranslatedValueFor('norton.details.isAlwaysProtectedFeatureFlag')??'false') === 'true');
    this.addSubscription(
      this._store.select(getUserProduct).subscribe((data) => {
        if (data?.packs?.length > 0 || data.outOfPacks?.length > 0) {
          this.extraServices = data.extraServices;
          this.installationAddresses = data.installationAddresses;
          this.outOfPacks = data.outOfPacks;
          this.packs = data.packs;
          this.emptyInstallBase = false;
          this.hasProductWithoutAddress = data.hasProductWithoutAddress;
          this.hasOnlyProductsWithoutAddress =
            Object.keys(this.installationAddresses).length === 0;
          this.firstCoreProduct = data.firstCoreProduct;
          this.overviewDataLoaded = true;
          this.isEshareUserJourneyEnabled = this.translationService.getTranslatedValueFor('products.addProduct.eshare.enable') === 'true';
          this.eshareMpcuidDisallowlist = this.translationService.getTranslatedValueFor('products.addProduct.eshare.mpcuidDisallowlist');

          if (this.isDynamicCtaActivated) {
            this.addSubscription(
              this._store.select(getCtaFilterConfig).pipe(
                delay(2000),
              ).subscribe((data) => {
                this.ctaFilterConfig = data;
                this.determinePackType();
                this.determineIntentPageFromEshare();
                this.determineLomIdFromEshare();


                if(this.currentPackType && this.itentFromEshare && this.ctaFilterConfig) {
                  this.filterUserResponseCtasAndRedirect();
                } else {
                  this.filterCtaApplied = true;
                }
              })
            )
          }

          this.addSubscription(
            this.customerService
              .getCustomerAccount()
              .subscribe((customerAccount: any) => {
                this.isRES = customerAccount?.isRES();
                this.isSE = customerAccount?.isSE();
                this.isEBU = customerAccount?.isEBU();
                this.isPrepaid = customerAccount?.isPrepaid();
                this.hasCustomerId = !!customerAccount?.getSelectedCustomer().customerId;
                if (
                  customerAccount &&
                  customerAccount.customerAccountResponse &&
                  customerAccount.customerAccountResponse.ownedMsisdns &&
                  customerAccount.customerAccountResponse.ownedMsisdns
                    .length === 1
                ) {
                  const msisdn =
                    customerAccount.customerAccountResponse.ownedMsisdns[0]
                      .msisdn;
                  this.myMobile = findMyMobileProduct(msisdn, this.packs);
                }
                this.custumerAccountName = customerAccount.customerAccountResponse?.firstName;
                this.initPackery();
              }),
          );

          if(this.isAlwaysProtectedFeatureFlag && this.isSE ) {
            this.checkForEasyProtect();
            this.checkForNorton()
          }
        } else {
          this.extraServices = [];
          this.installationAddresses = {};
          this.outOfPacks = [];
          this.outOfPacksFiberEligible = false;
          this.packs = [];
          this.hasProductWithoutAddress = false;
          this.hasOnlyProductsWithoutAddress = false;
          this.firstCoreProduct = undefined;
          this.overviewDataLoaded = true;
          this.emptyInstallBase = true;
        }
      }),
    );

    this.addSubscription(
      this._store.select(getProductsEmbeddedErrors).subscribe((errors) => {
        if (errors && errors.length > 0) {
          this.emptyInstallBaseNewCust =
            errors.find(
              (error: any) => error.code === 'EMPTY_INSTALL_BASE_NEW_CUST',
            ) !== undefined;
          this.emptyInstallBaseCeaseCust =
            errors.find(
              (error: any) => error.code === 'EMPTY_INSTALL_BASE_CEASE_CUST',
            ) !== undefined;
          this.emptyInstallBase =
            errors.find((error: any) => error.code === 'EMPTY_INSTALL_BASE') !==
            undefined;
          this.emptyInstallBaseV1Cust =
            errors.find(
              (error: any) => error.code === 'EMPTY_INSTALL_BASE_V1',
            ) !== undefined;
        } else {
          this.emptyInstallBaseCeaseCust = false;
          this.emptyInstallBaseNewCust = false;
          this.emptyInstallBaseV1Cust = false;
        }
      }),
    );

    this.addSubscription(
      this._store.select(getProductsTechnicalError).subscribe((error) => {
        if (error !== null) {
          this.overviewDataLoaded = false;
        }
      }),
    );
    this.addSubscription(
      this._store.select(getProductsPending).subscribe((pending) => {
        this.isPending = pending;
      }),
    );

    this.addSubscription(
      this._store.select(getSelectedAddress).subscribe((data) => {
        this.selectedAddress = data;
        this.initPackery();
      }),
    );

    this.addSubscription(
      this._store.select(getProductsRedirectedToDetails).subscribe((value) => {
        this.alreadyRedirected = value;
      }),
    );

    this.addSubscription(
      this._store.select(getCopperOutPhasingOffer).subscribe((value) => {
        this.copperOutPhasingOffer = value;
      }),
    );

  }

  shouldHideSelector() {
    const numberOfAddresses =
      this.installationAddresses &&
      Object.keys(this.installationAddresses).length;
    return (
      !this.overviewDataLoaded ||
      this.emptyInstallBase ||
      this.emptyInstallBaseCeaseCust ||
      this.emptyInstallBaseNewCust ||
      this.emptyInstallBaseV1Cust ||
      (numberOfAddresses === 1 && !this.hasProductWithoutAddress) ||
      (numberOfAddresses === 0 && this.hasProductWithoutAddress)
    );
  }

  public hasCtaProduct(outOfPack: any) {
    return !!outOfPack?.coreProducts?.find((product) => product.ctaProducts);
  }

  public getOutOfPacksCtaProduct(outOfPack: any) {
    return outOfPack?.coreProducts?.find((product) => product.ctaProducts);
  }

  private containsFiberEligibleProducts(outOfPack) {
    return !!outOfPack?.coreProducts?.some(
      (product) => product.isFiberEligible,
    );
  }

  private initPackery() {
    setTimeout(() => {
      inception.masonry('[data-masonry-container]');
    });
  }

  private getProducts() {
    const appBrand = this.translationService.getTranslatedValueFor('app.brand');
    this._store.dispatch(
      new ProductsActions.GetProducts({
        appBrand: appBrand ? appBrand : 'proximus',
      }),
    );
    this._store.dispatch(new MagnoliaConfigActions.GetOptionGroupsConfig())
  }

  get showProducts() {
    return (
      this.packs.length > 0 ||
      this.outOfPacks.length > 0 ||
      this.extraServices.length > 0 ||
      this.emptyInstallBase ||
      this.emptyInstallBaseCeaseCust ||
      this.emptyInstallBaseNewCust ||
      this.emptyInstallBaseV1Cust
    );
  }

  private getCopperOutPhasingOffer() {
    const customerAccount$ = this.customerService?.getCustomerAccount?.();
    if (!customerAccount$?.pipe) {
      return;
    }

    this.addSubscription(
      customerAccount$
        .pipe(
          take(1),
          tap((customerAccount: any) => {
            if (!customerAccount?.isEBU()) {
              this._store.dispatch(new OffersActions.GetCopperOutPhasingOffer());
            }
          })
        )
        .subscribe(),
    );
  }

  navigateToAddAProduct(pack: any, isOutOfPack = false, category?: string): void {
    const product = isOutOfPack ? this.getOutOfPacksCtaProduct(pack) : pack;
    this.saveToPII(product, isOutOfPack);

    if (this.isEshareUserJourneyEnabled && shouldRedirectToEshareUserJourney(getProductMpcuidList(product), this.eshareMpcuidDisallowlist)) {
      this.navigateToNewEshareUserJourney(product, category);
    } else {
      this.navigateToDefaultAddProduct(category);
    }
  }

  navigateToNewEshareUserJourney(pack: any, category?: string): void {
    const token = pack?.ewebToken;
    const eshareUserJourneyUrl = this.translationService.getTranslatedValueFor('products.addProduct.eshare.url');

    if (eshareUserJourneyUrl && token) {
      this.redirectToEshareXsellUrl(eshareUserJourneyUrl, token);
    } else {
      this.navigateToDefaultAddProduct(category);
    }
  }

  getPanelClass(): string {
    return this.brandService.isScarlet() ? '' : 'rs-bg-purple3';
  }

  private navigateToDefaultAddProduct(category?: string): void {
    if (this.isDynamicCtaActivated && category) {
      this.router.navigate(['/add-product', category]);
    } else {
      this.router.navigate(['/add-product']);
    }
  }


  private saveToPII(
    product: {
      ctaProducts: any;
      productId: any;
      plc: any;
      packId: any;
      productDescription: any;
      packDescription: any;
      isBelfiusPartner: any;
      isEshare1p2pEligible: boolean;
      isFiberEligible: boolean;
      eshareToken: string;
      eshare1p2pToken: string;
    },
    outOfPack = false,
  ) {
    savePiiProduct({
      ctaProducts: product.ctaProducts,
      productId: outOfPack ? product.productId : undefined,
      plc: outOfPack ? product.plc : undefined,
      packId: outOfPack ? undefined : product.packId,
      taggingName: outOfPack
        ? product.productDescription
        : product.packDescription,
      isBelfiusPartner: product.isBelfiusPartner || false,
      isOutOfPack: outOfPack,
      isEshare1p2pEligible: product?.isEshare1p2pEligible,
      isFiberEligible: product?.isFiberEligible,
      eshareToken: product?.eshareToken,
      eshare1p2pToken: product?.eshare1p2pToken,
      customerAccountName: this.custumerAccountName,
      productMpcuids: getProductMpcuidList(product)
    });
  }
 public checkForEasyProtect() {
   const coreProducts = this.packs.flatMap(pack => pack.coreProducts);
    const pxsSecureNetFixOrMobileProd = this.packs.flatMap(pack => pack.nonCoreProducts);
    const notStandAlone = pxsSecureNetFixOrMobileProd?.filter(
      secureProd => secureProd && (secureProd.productDescription === PXS_SECURE_NET_FIX
        || secureProd.productDescription === PXS_SECURE_NET_MOBILE)
    ).flat();
    const easyProtectPack = this.packs.find(pack =>
      pack.coreProducts?.some(product =>
        product?.options?.some(option => option.technicalName === EASY_PROTECT_NAME)
      )
    );
    const easyProtectPackId = easyProtectPack ? easyProtectPack.packId : null;
    this.alwaysProtectedService.easyProtectPackId(easyProtectPackId)
    const easyProtectProduct = coreProducts.find(product =>
      product?.options?.some(option => option.technicalName === EASY_PROTECT_NAME)
    );
    if (easyProtectProduct) {
      this.easyProtectOptions = easyProtectProduct.options;
      notStandAlone ? this.easyProtectOptions.push(notStandAlone) : this.easyProtectOptions
      this.easyProtectOptions = this.easyProtectOptions.flat()
      // setting the easyProtect flag to true
      this.easyProtectFlag = true;
      this.alwaysProtectedService.checkAlwaysProtected(true);
    }
  }


  public checkForNorton() {
    this.outOfPackNorton = this.outOfPacks.flatMap(outofpack =>
      outofpack.nonCoreProducts.filter(product => product.productDescription === NORTON_SEC_5)
    );

    this.outOfPackNorton.length>1 ? this.outOfPackNorton = this.outOfPackNorton.splice(1) : this.outOfPackNorton;
    // norton 5 subscriptions count
    const nortonSecurity5 = this.easyProtectOptions.find(a => a.name === 'Norton Security 5');
    this.norton5Count = this.countProduct(this.outOfPackNorton,this.translationService.getTranslatedValueFor('norton.subscription.norton5MpcUuid'));

    if (this.outOfPackNorton.length > 0) {
      this.isOutOfPackNorton = true;
      this.easyProtectOptions = [...this.easyProtectOptions, ...this.outOfPackNorton];

      if(this.norton5Count>1) {
        this.nortonSubscriptionGreaterThanOne = true;
      }
    } else {
      this.checkForEasyProtect();
    }
    this.alwaysProtectedProducts()
  }

  private alwaysProtectedProducts() {

this.easyProtectOptions = this.easyProtectOptions.flat();
    this.hasProductDescription = this.easyProtectOptions.some(
      item =>
        item.productDescription === 'Proximus Secure Net Fix' ||
        item.productDescription === 'Proximus Secure Net Mobile' ||
        item.productDescription === 'Norton Security 5'
    );


    if (this.hasProductDescription) {
      // Filter out objects with name as Proximus Secure Net Fix or Proximus Secure Net Mobile
      this.filteredData = this.easyProtectOptions.filter(
        item =>
          item.productDescription === 'Proximus Secure Net Fix' ||
          item.productDescription === 'Proximus Secure Net Mobile' ||
          item.productDescription === 'Norton Security 5'
      ).filter(
        item =>
          item.name !== 'Proximus Secure Net Fix' &&
          item.name !== 'Proximus Secure Net Mobile'
      );
    } else {
      // Show objects with name as Proximus Secure Net Fix or Proximus Secure Net Mobile and productDescription as Norton Security 5
      this.filteredData = this.easyProtectOptions.filter(
        item =>
          (item.name === 'Proximus Secure Net Fix' ||
            item.name === 'Proximus Secure Net Mobile') &&
          item.productDescription === 'Norton Security 5'
      );
    }

    this.alwaysProtectedService.alwaysProtectedValue(this.filteredData);
  }

  private determinePackType() {
    if (this.isMobileOnly()) {
      this.currentPackType = OverviewPackType.mobileOnly;
    } else if (this.isInternetOnly()) {
      this.currentPackType = OverviewPackType.internetOnly;
    } else if (this.isMobileAndInternet()) {
      this.currentPackType = OverviewPackType.mobileAndInternet;
    } else if (this.isPackWithMobile()) {
      this.currentPackType = OverviewPackType.packWithMobile;
    } else if (this.isPackWithoutMobile()) {
      this.currentPackType = OverviewPackType.packWithoutMobile;
    } else {
      this.currentPackType = null;
    }
  }

  private determineIntentPageFromEshare() {
    this.isDynamicCtaActivated = this.translationService.getTranslatedValueFor('products.overview.isDynamicCtaActivatedFeatureFlag') === 'true';
    if (this.isDynamicCtaActivated && this.route.snapshot.queryParams['intent']) {
      this.itentFromEshare = this.route.snapshot.queryParams['intent'];
    }
  }

  private determineLomIdFromEshare() {
    this.isDynamicCtaActivated = this.translationService.getTranslatedValueFor('products.overview.isDynamicCtaActivatedFeatureFlag') === 'true';
    if (this.isDynamicCtaActivated && this.route.snapshot.queryParams['lomid']) {
      this.lomIdFromEshare = this.route.snapshot.queryParams['lomid'];
    }
  }

  private determineMpcuidFromEshare() {
    if (this.route.snapshot.queryParams['mpcuid']) {
      this.mpcuidFromEshare = this.route.snapshot.queryParams['mpcuid'];
    }
  }

  private determineActionFromEshare() {
    if (this.route.snapshot.queryParams['action']) {
      this.actionFromEshare = this.route.snapshot.queryParams['action'];
    }
  }

  private getFilterFromConfig() {
    if (this.itentFromEshare && this.currentPackType) {
      return this.ctaFilterConfig[this.itentFromEshare]?.filter((filter: any) => filter.packType === this.currentPackType);
    }

    return null;
  }

  private getUnfilteredCtaListFromUserResponse():  MultiLanguageLinkConfig[] {
    return this.currentPackType === OverviewPackType.mobileOnly || this.currentPackType === OverviewPackType.internetOnly || this.currentPackType === OverviewPackType.mobileAndInternet ?
      this.outOfPacks.find((pack) => pack.coreProducts.find((product) => !!product.ctaProducts))?.coreProducts[0].ctaProducts :
          this.currentPackType === OverviewPackType.packWithMobile || this.currentPackType === OverviewPackType.packWithoutMobile ?
            this.packs.find((pack) => pack.addressKey === this.addressKeyForRedirect)?.ctaProducts : [];
  }

  private filterUserResponseCtasAndRedirect(): void {
    const unfilteredCtaList = this.getUnfilteredCtaListFromUserResponse();
    const filter = this.getFilterFromConfig();
    const filteredCtaList = !filter ? unfilteredCtaList : this.filterItemsByConfig(unfilteredCtaList, filter, this.languageService.getSelectedLanguage());
    const redirected = this.handleSpecialDirectRedirections(filteredCtaList);

    if(redirected) {
      return;
    }

    if(this.currentPackType === OverviewPackType.mobileOnly || this.currentPackType === OverviewPackType.internetOnly || this.currentPackType === OverviewPackType.mobileAndInternet) {
      const outOfPackToRedirect = this.outOfPacks.find((pack: any) => pack.coreProducts.find((product: any) => product.ctaProducts === unfilteredCtaList));
      const productToModifyCta = this.getOutOfPacksCtaProduct(outOfPackToRedirect);
      productToModifyCta.ctaProducts = filteredCtaList

      this.navigateToAddAProduct(outOfPackToRedirect, true, this.itentFromEshare);
    } else if(this.currentPackType === OverviewPackType.packWithMobile || this.currentPackType === OverviewPackType.packWithoutMobile) {
      const packToRedirect = this.packs.find((pack: any) => pack.addressKey === this.addressKeyForRedirect);

      if(packToRedirect) {
        packToRedirect.ctaProducts = filteredCtaList;
        this.navigateToAddAProduct(packToRedirect, false, this.itentFromEshare);
      }
    }
  }

  private getConfigFromCta(cta: MultiLanguageLinkConfig): OverviewCtaFilter {
    return this.getFilterFromConfig()?.find((filter: any) => {
      const [ctaLink, ctaUrl, scenario] = filter.cta;
      let matchLink = false;
      let matchUrl = false;
      let matchScenario = false;

      if (ctaLink && cta.link) {
        matchLink = cta.link.includes(ctaLink);
      }

      if (ctaUrl && cta.url) {
        matchUrl = cta.url[this.languageService.getSelectedLanguage()]?.includes(ctaUrl);
      }

      if (cta.eshareToken) {
        const ctaEshareDecodedToken = JwtUtils.decodeToken(cta.eshareToken);
        matchScenario = ctaEshareDecodedToken.scenario === scenario;
      }

      return matchLink || matchUrl || matchScenario;
    });
  }

  private handleSpecialDirectRedirections(ctaList: MultiLanguageLinkConfig[]) {
    if(!ctaList || ctaList?.length === 0) {
      return false;
    } else if (ctaList.length === 1) {
      const config = this.getConfigFromCta(ctaList[0]);
      if (config.doAutoRedirect) {
        this.redirectToProductCtaUrl(ctaList[0]);
        return true;
      }
    } else if (ctaList.length === 2 && this.route.snapshot.queryParams['lomid']) {

      const filteredCtaListWithLomIdCheck = ctaList.filter((cta: MultiLanguageLinkConfig) => {
        return this.getConfigFromCta(cta)?.doCheckLomId;
      });

      const lomIdFromQueryParams = this.route.snapshot.queryParams['lomid'];
      const outOfPackWithAddressKey = this.outOfPacks.find((pack: any) => !!pack.addressKey);
      const isSameLomId =  outOfPackWithAddressKey && (this.installationAddresses[(outOfPackWithAddressKey as any).addressKey] as any)?.lomKey === lomIdFromQueryParams;

      if(filteredCtaListWithLomIdCheck.length === 1 && isSameLomId) {
        const config = this.getConfigFromCta(filteredCtaListWithLomIdCheck[0]);

        if (config.doAutoRedirect) {
          this.redirectToProductCtaUrl(filteredCtaListWithLomIdCheck[0]);
          return true;
        }
      } else if(!isSameLomId) {
        const filteredCtaListWithNotLomIdCheck = ctaList.filter((cta: MultiLanguageLinkConfig) => {
          return !this.getConfigFromCta(cta)?.doCheckLomId;
        });

        if(filteredCtaListWithNotLomIdCheck.length === 1) {
          const config = this.getConfigFromCta(filteredCtaListWithNotLomIdCheck[0]);

          if (config.doAutoRedirect) {
            this.redirectToProductCtaUrl(filteredCtaListWithNotLomIdCheck[0]);
            return true;
          }
        }
      }

    }

    return false;
  }

  private isMobileOnly() {
    return this.packs?.length === 0 && this.outOfPacks.length > 0 &&
      this.outOfPacks.some((pack: any) => pack.coreProducts.some((product) => product.plc === 'MV')) &&
      !this.outOfPacks.some((pack: any) => pack.coreProducts.some((product) => product.plc === 'FI'));
  }

  private isInternetOnly() {
    return this.packs?.length === 0 && this.outOfPacks.length > 0 &&
      !this.outOfPacks.some((pack: any) => pack.coreProducts.some((product) => product.plc === 'MV')) &&
      this.outOfPacks.some((pack: any) => pack.coreProducts.some((product) => product.plc === 'FI'));
  }

  private isMobileAndInternet() {
    return this.packs?.length === 0 && this.outOfPacks.length > 0 &&
      this.outOfPacks.some((pack: any) => pack.coreProducts.some((product) => product.plc === 'MV')) &&
      this.outOfPacks.some((pack: any) => pack.coreProducts.some((product) => product.plc === 'FI'));
  }

  private isPackWithMobile() {
    const lomIdFromQueryParams = this.route.snapshot.queryParams['lomid'];

    if (this.packs.length > 1 && lomIdFromQueryParams) {
      const index = this.packs.findIndex((pack: any) => pack.coreProducts.some((product) => (this.installationAddresses[product.addressKey] as any)?.lomKey === lomIdFromQueryParams));
      if (index > -1) {
        this.addressKeyForRedirect = this.packs[index].addressKey;
        return this.packs[index].coreProducts.some((pack: any) => pack.plc === 'MV');
      }
      return index > -1 && this.packs[index].coreProducts.some((pack: any) => pack.plc === 'MV');

    } else if (this.packs.length === 1) {
      this.addressKeyForRedirect = this.packs[0].addressKey
      return this.packs[0].coreProducts?.some((pack: any) => pack.plc === 'MV');
    }

    return false;
  }

  private isPackWithoutMobile() {
    const lomIdFromQueryParams = this.route.snapshot.queryParams['lomid'];

    if (this.packs.length > 1 && lomIdFromQueryParams) {
      const index = this.packs.findIndex((pack: any) => pack.coreProducts.some((product) => (this.installationAddresses[product.addressKey] as any)?.lomKey === lomIdFromQueryParams));
      return index > -1 && !this.packs[index].coreProducts.some((pack: any) => pack.plc === 'MV');

    } else if (this.packs.length === 1) {
      return !this.packs[0].coreProducts?.some((pack: any) => pack.plc === 'MV');
    }

    return false;
  }

  private filterItemsByConfig(
    items: MultiLanguageLinkConfig[],
    configs: OverviewCtaFilter[],
    selectedLanguage = 'en'
  ): MultiLanguageLinkConfig[] {
    return items?.filter(item =>
      configs?.some(cfg => {
        const [ctaLink, ctaUrl, scenario] = cfg.cta;
        let matchLink = false;
        let matchUrl = false;
        let matchScenario = false;

        if (ctaLink && item.link) {
          matchLink = item.link.includes(ctaLink);
        }

        if (ctaUrl && item.url) {
          matchUrl = item.url[selectedLanguage]?.includes(ctaUrl);
        }

        if (item.eshareToken) {
          const ctaEshareDecodedToken = JwtUtils.decodeToken(item.eshareToken);
          matchScenario = ctaEshareDecodedToken.scenario === scenario;
        }

        return matchLink || matchUrl || matchScenario;
      })
    );
  }

  private redirectToProductCtaUrl(cta: MultiLanguageLinkConfig): void {
    if (cta.link) {
      const linkWithFiberExtremeQueryParam= this.appendFiberExtremeRedirectionOrigin(cta.link);
      window.open(linkWithFiberExtremeQueryParam, '_self');
    } else if (cta.url && cta.url[this.languageService.getSelectedLanguage()]) {
      if(cta.eshareToken) {
        this.redirectToEshareXsellUrl(cta.url[this.languageService.getSelectedLanguage()], cta.eshareToken);
      } else {
        const linkWithFiberExtremeQueryParam = this.appendFiberExtremeRedirectionOrigin(cta.url[this.languageService.getSelectedLanguage()]);
        window.open(linkWithFiberExtremeQueryParam, '_self');
      }
    }
  }

  private appendFiberExtremeRedirectionOrigin(url: string): string {
    if (url.includes('redirection_origin=fiber-extreme') || !this.itentFromEshare) {
      return url;
    }
    if (url.includes('?')) {
      return url + '&redirection_origin=fiber-extreme';
    }
    return url + '?redirection_origin=fiber-extreme';
  }

  private redirectToEshareXsellUrl(url: string, token: string): void {
    window.open(this.constructUrl(url, token), '_self');
    return;
  }

  private constructUrl(url: string, token: string) {
    return constructEshareUrl(url, token, {
      intent: this.itentFromEshare,
      lomid: this.lomIdFromEshare,
      mpcuid: this.mpcuidFromEshare,
      action: this.actionFromEshare
    });
  }

  private countProduct(products: Array<Product>, groupMpcUuid: string) {
    return Object.values(products).filter((product) => groupMpcUuid === product.groupMpcUuid).length;
  }
}
